module.exports = __webpack_public_path__ + "menu-blue.png?9fc2d09680c565d77f2c34483ae3f759";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-blue.png
// module id = 683
// module chunks = 0 2 7 8 9 10